import { useLazyQuery } from '@apollo/client'
import type { ApolloError, LazyQueryExecFunction } from '@apollo/client'
import {
  GET_CACHE_EDIT_PAGE_DETAILS,
  GetCacheEditPageDetailsResponse,
  GetCacheEditPageDetailsVariables,
} from '../queries/get-cache-edit-page-details'

type CacheEditPageDetailsData = GetCacheEditPageDetailsResponse['cacheEditPageDetails']

type UseGetCacheEditPageDetailsResult = {
  getCacheEditPageDetails: LazyQueryExecFunction<
    GetCacheEditPageDetailsResponse,
    GetCacheEditPageDetailsVariables
  >
  data: CacheEditPageDetailsData | undefined
  loading: boolean
  error: ApolloError | undefined
}

export const useGetCacheEditPageDetails = (): UseGetCacheEditPageDetailsResult => {
  const [getCacheEditPageDetails, { data, loading, error }] = useLazyQuery<
    GetCacheEditPageDetailsResponse,
    GetCacheEditPageDetailsVariables
  >(GET_CACHE_EDIT_PAGE_DETAILS, {
    fetchPolicy: 'network-only',
  })

  return {
    getCacheEditPageDetails,
    data: data?.cacheEditPageDetails,
    loading,
    error,
  }
}
